import { NavButton } from "@src/components/navButton/NavButton";
import { ReactComponent as CheckCircle } from "@src/svg/check-circle.svg";
import { environment } from "@src/MarqueBlanche";
import "./confirmSimulation.scss";

export type ConfirmSimulationData = undefined;

export function ConfirmSimulation() {
  return (
    <div className="confirm-simulation-step">
      <div className="stepper__centered-container">
        <div className="stepper__centered-content step__grid confirm-simulation-step__main">
          <CheckCircle className="confirm-simulation-step__svg" />
          <h1>Votre devis vous a été envoyé par mail</h1>
          <p>Vérifiez votre boîte de courriers indésirables.</p>
          <NavButton
            onClick={() =>
              window.location.replace(environment.current.maisonMereUrl)
            }
          >
            Retour au site
          </NavButton>
        </div>
      </div>
    </div>
  );
}
